import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Card from './Card';

const Share = ({ showShare, handleShowShare, content, timeline }) => {
    const { qrcode } = timeline;

    return (
        <>
            {showShare ? (
                <Card qrcode={qrcode} content={content} timeline={timeline} handleShowShare={handleShowShare} />
            ) : null}
        </>
    );
};

Share.propTypes = {
    showShare: PropTypes.bool,
    handleShowShare: PropTypes.func,
    content: PropTypes.object,
    timeline: PropTypes.object,
};

export default errorBoundary(Share);
